import $ from 'jquery';
import events from './events.js';

const CSSCLASSES = {
        errorCon: 'w-alert-con',
        jsHide: 'w-js-hide'
    },
    formId = 'w-start-form',
    allowedFormElementSelectors = 'select, input[type=text]';

let $form; // cache form element.

function showErrorMsg($container) {
    var $errorMsgCon = $container.find('.' + CSSCLASSES.errorCon);
    if ($errorMsgCon.length) {
        $errorMsgCon.removeClass(CSSCLASSES.jsHide);
    }
}

function isEmpty($element) {
    return $element && !$element.val().length;
}

function submitButtonClick(e) {
    e.preventDefault();

    var $formElements = $form.find(allowedFormElementSelectors),
        // returns an array of elements with a value set
        $emptyElements = $formElements.filter(function(index, element) {
            return !isEmpty($(element));
        }),
        $horseNameDropdown = $('#horse_name_sel'),
        hasInvalidNameSelected = $('#RecipientName').val()
                 .toLowerCase()
                 .trim() === 'me' || 
                 $horseNameDropdown.find('option:selected')
                 .text()
                 .toLowerCase() === 'me'; // check if any value set to Me

    // if elements with no values set show error
    if (!$emptyElements.length) {
        showErrorMsg($(e.currentTarget).closest('.intro-grid'));
        $horseNameDropdown.focus();
    } else if (hasInvalidNameSelected) {
        // show modal error
        smartPak.ui.modal(
            $('<strong class="alertTxt">Please enter a valid animal name</strong>').get(0),
            {
                title: 'Error',
                removeContents: true,
                resizable: false
            }
        );
    } else {
        // all is good, submit form
        $form.trigger('submit');
    }
}

function setUpFormEvents($form) {
    $form
        .on('click', '.viewResults', function(e) {
            e.preventDefault();
            $('#horse_name_sel').val('');
        })
        .on('click', '#wizardGetStarted', function(e) {
            e.preventDefault();
            $('#horse_name_sel_results').val('');
        })
        .on('click', 'input:submit', submitButtonClick);
}

function initializeHorseNameForm() {
    $form = $('#' + formId);

    // if there is not a form exit early and throw an error.
    if (!$form.length) {
        throw new Error('Could not find a form element within the DOM with the id "' + formId + '".');
    }

    setUpFormEvents($form);
}

function setUpInputManagement() {
    var $customerType = $('#SurveyCustomerType'),
        $horseSelect = $('#horse_name_sel'),
        $horseName = $('#RecipientName'),
        $lookupHorseSelect = $('#horse_name_sel_results');

    if ($customerType.val() === 'CustomerWithHorses') {
        $horseSelect.on('change', function() {
            $horseName.val('');
        });
        $horseName.on('keyup', function(e) {
            if (e.target.value) {
                if ($horseSelect.val()) {
                    $horseSelect.val('');
                }

                if ($lookupHorseSelect.val()) {
                    $lookupHorseSelect.val('');
                }
            }
        });
    }
}

function manageHorseDropDowns() {
    var $dropdowns = $('.horse-selector');

    $dropdowns.on('change', function(e) {
        $dropdowns.filter(':not(#' + e.target.id + ')').val('');
    });
}

export default function recipientForm() {
    var $form = $('#' + formId);

    initializeHorseNameForm();
    setUpInputManagement();
    manageHorseDropDowns();
    events.addGetStartedEventListener($form);
    events.addPreviousResultEventListener($form);
    events.addSelectHorseEventListener($form);
    events.addNewHorseEventListener($form);
}
